export enum FileMimeType {
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  HEIC = 'image/heic',
  HEIF = 'image/heif',
  PDF = 'application/pdf',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}

export enum FileExtension {
  JPG = '.jpg',
  JPEG = '.jpeg',
  PNG = '.png',
  HEIC = '.heic',
  HEIF = '.heif',
  PDF = '.pdf',
  DOC = '.doc',
  DOCX = '.docx',
  XLS = '.xls',
  XLSX = '.xlsx'
}

